"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ButtonWrapper = exports.SectionBody = exports.SectionContainer = exports.SectionWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _styledSystem = require("styled-system");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Typography = require("../Typography");

var SectionWrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      sectionHeader = _ref$theme.sectionHeader,
      bgColor = _ref.bgColor;
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: bgColor === 'secondary' ? "".concat(space[sectionHeader.componentPadding], " 0") : 0
  };
});
exports.SectionWrapper = SectionWrapper;
var SectionContainer = (0, _styled.default)(_ComponentWrapper.default)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      sectionHeader = _ref2$theme.sectionHeader;
  return (0, _styledSystem.variant)({
    prop: 'bgColor',
    variants: {
      primary: {
        backgroundColor: colors[sectionHeader.bgColorPrimary]
      },
      secondary: {
        backgroundColor: colors[sectionHeader.bgColorSecondary]
      }
    }
  });
});
exports.SectionContainer = SectionContainer;
var SectionBody = (0, _styled.default)(_Typography.Body)(function (_ref3) {
  var _ref4;

  var space = _ref3.theme.space,
      hasTitle = _ref3.hasTitle,
      position = _ref3.position;
  return _ref4 = {
    textAlign: position,
    width: '100%',
    marginTop: hasTitle ? space.base : 0
  }, _defineProperty(_ref4, _mediaQueries.default.small, {
    marginTop: hasTitle ? space.large : 0
  }), _defineProperty(_ref4, 'p:last-of-type', {
    marginBottom: 0
  }), _defineProperty(_ref4, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    flex: '0 0 auto'
  }), _ref4;
});
exports.SectionBody = SectionBody;
var ButtonWrapper = (0, _styled.default)('div')(function (_ref5) {
  var _ref6;

  var _ref5$theme = _ref5.theme,
      space = _ref5$theme.space,
      sectionHeader = _ref5$theme.sectionHeader,
      justifyContent = _ref5.justifyContent;
  return _ref6 = {
    display: 'flex',
    flexWrap: sectionHeader.buttonFlexWrap,
    justifyContent: justifyContent,
    '> *:first-of-type': {
      marginRight: space.base
    }
  }, _defineProperty(_ref6, _mediaQueries.default.small, {
    '> a:first-of-type': {
      marginRight: 'inherit'
    }
  }), _defineProperty(_ref6, _mediaQueries.default.medium, {
    flexWrap: 'nowrap'
  }), _ref6;
});
exports.ButtonWrapper = ButtonWrapper;